import React from 'react';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import bowser from 'yola-bowser';
import Icon from '../icon';
import Tooltip from '../tooltip';
import { APPEARANCES, SIZES } from './constants';
const defaultTooltipProps = {};

const IconButton = ({
  icon = null,
  glyph = 'icons',
  iconStrokeWidth = 1.3,
  label = undefined,
  size = SIZES.extraLarge,
  iconSize = undefined,
  appearance = APPEARANCES.light,
  transparent = false,
  selected = false,
  disabled = false,
  tooltipProps = defaultTooltipProps,
  onClick = undefined,
  onMouseDown = undefined,
  onMouseUp = undefined,
  onKeyDown = undefined,
  tabIndex = undefined,
}) => {
  const classes = classNames(
    `ws-ui-icon-button`,
    `ws-ui-icon-button--size-${size}`,
    `ws-ui-icon-button--appearance-${appearance}`,
    {
      'ws-ui-icon-button--transparent': transparent,
      'ws-ui-icon-button--selected': selected,
    }
  );
  const iconClasses = classNames('ws-ui-icon-button__icon', {
    'ws-ui-icon-button__icon--custom-size': !!iconSize,
  });

  const isTouchDevice = bowser.mobile || bowser.tablet;
  const isTooltipEnabled = !!label && !isTouchDevice;
  const tooltipId = `icon_button_${uuid()}`;
  const tooltipAttrsForButton = {
    'data-tip': true,
    'data-for': tooltipId,
  };

  const tooltipPropsWithDefaults = {
    ...tooltipProps,
    id: tooltipProps.id || tooltipId,
    text: tooltipProps.text || label,
  };

  return (
    <React.Fragment>
      <button
        onClick={onClick}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onKeyDown={onKeyDown}
        tabIndex={tabIndex}
        disabled={disabled}
        className={classes}
        {...(isTooltipEnabled && tooltipAttrsForButton)}
      >
        {icon ? (
          <div className="ws-ui-icon-button__icon ws-ui-icon-button__icon--custom">{icon}</div>
        ) : (
          <div className={iconClasses}>
            <Icon
              glyph={glyph}
              type="inherit"
              size={iconSize || '100%'}
              strokeWidth={iconStrokeWidth}
            />
          </div>
        )}
      </button>

      {isTooltipEnabled && <Tooltip {...tooltipPropsWithDefaults} />}
    </React.Fragment>
  );
};

export default IconButton;
